// extracted by mini-css-extract-plugin
export default {"title":"Invoices_title__m+Fo3","boxForm":"Invoices_boxForm__e9c5M","form":"Invoices_form__DhbEY"};